<template>
    <div></div>
  <!-- <transition name="toast-fade">
    <div v-if="show" class="toast" :class="typeClass">
      <div class="toast__content">
        <div class="toast__title">{{ title }}</div>
        <div class="toast__message">{{ message }}</div>
      </div>
      <button class="toast__close" @click="hide">×</button>
    </div>
  </transition> -->
</template>

<script>
import { EventBus } from '@/event-bus';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  name: 'NotificationToast',
  data() {
    return {
      show: false,
      title: 'Notification',
      message: '',
      type: 'info',
      timeout: null,
      duration: 3000,
    };
  },
  created() {
    EventBus.$on('notify', this.open);
  },
  beforeDestroy() {
    EventBus.$off('notify', this.open);
    clearTimeout(this.timeout);
  },
  computed: {
    typeClass() {
      return `toast--${this.type}`;
    },
  },
  methods: {
    makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    open(payload) {
        
      // รองรับทั้ง string หรือ object
      if (typeof payload === 'string') {
        this.title = 'Notification';
        this.message = payload;
        this.type = 'info';
        this.duration = 3000;
      } else {
        
        this.title = payload.title || 'Notification';
        this.message = payload.message || '';
        this.type = payload.type || 'info';
        this.duration = payload.duration || 3000;
        this.makeToast( this.type,this.type ,  this.message);
      }

      this.show = true;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.show = false;
      }, this.duration);
    },
    hide() {
      this.show = false;
      clearTimeout(this.timeout);
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 16px;
  right: 16px;
  width: 320px;
  padding: 12px 12px 12px 14px;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 10px 30px rgba(0,0,0,.18);
  z-index: 99999;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.toast__content { flex: 1; }
.toast__title { font-weight: 700; font-size: 14px; margin-bottom: 2px; }
.toast__message { font-size: 13px; line-height: 1.35; opacity: .95; }

.toast__close {
  background: transparent;
  border: 0;
  color: rgba(255,255,255,.9);
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 2px 6px;
}

/* type colors */
.toast--info { background: #409EFF; }
.toast--success { background: #42b883; }
.toast--error { background: #F56C6C; }
.toast--warning { background: #E6A23C; }

.toast-fade-enter-active, .toast-fade-leave-active {
  transition: opacity .25s, transform .25s;
}
.toast-fade-enter, .toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>